@if (videoUrl) {
    <div class="media-article-card">
        <nw-video
            [videoUrl]="videoUrl"
            [thumbnail]="thumbnail"
            [altText]="videoAltText"
            [duration]="duration"
            class="media-article-card__video"
        ></nw-video>

        <div class="media-article-card__body">
            @if (category) {
                <h6 class="media-article-card__body__category">{{ category }}</h6>
                <div
                    class="media-article-card__body__underline"
                    [style.backgroundColor]="categoryColor"
                ></div>
            }
            <h4 class="media-article-card__body__title" [class.margin-top-m]="category">
                {{ title }}
            </h4>
            <div
                class="media-article-card__body__footer"
                [class.media-article-card__body__footer--no-date]="!publishedDate"
                [class.media-article-card__body__footer--no-avatar]="!avatar"
            >
                @if (avatar) {
                    <img
                        class="media-article-card__body__footer__avatar"
                        [ngSrc]="avatar"
                        [alt]="(author || '') + ' avatar'"
                        height="20"
                        width="20"
                    />
                }
                @if (author) {
                    <h6
                        class="media-article-card__body__footer__author"
                        [class.padding-left-m]="avatar"
                    >
                        {{ author }}
                    </h6>
                }
                @if (publishedDate) {
                    <p class="media-article-card__body__footer__date">
                        {{ publishedDate }}
                    </p>
                }
                <nw-pill class="media-article-card__body__footer__pill">
                    <div class="media-article-card__body__footer__pill__content">
                        <nw-icon>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 16"
                            >
                                <path
                                    fill="currentColor"
                                    d="M0 2.667A2.67 2.67 0 0 1 2.667 0h10.666A2.67 2.67 0 0 1 16 2.667v10.666A2.67 2.67 0 0 1 13.333 16H2.667A2.67 2.67 0 0 1 0 13.333V2.667Zm23.296-1.175c.433.233.704.683.704 1.175v10.666a1.334 1.334 0 0 1-2.075 1.109l-4-2.667-.592-.396V4.621l.592-.396 4-2.667c.408-.27.933-.3 1.37-.066Z"
                                />
                            </svg>
                        </nw-icon>
                        <span>Video</span>
                    </div>
                </nw-pill>
            </div>
        </div>
    </div>
} @else {
    <a
        class="media-article-card"
        [attr.href]="clickableUrl || null"
        (mouseenter)="mouseEnter()"
        (mouseleave)="mouseLeave()"
    >
        @if (image) {
            <div class="media-article-card__media">
                <img
                    class="media-article-card__media__img"
                    [ngSrc]="image"
                    height="200"
                    width="200"
                    alt="media card image"
                    nwTint
                    [tint]="imageTint"
                    [id]="'image-tint-' + id"
                />
            </div>
        }
        <div class="media-article-card__body">
            @if (category) {
                <h6 class="media-article-card__body__category">{{ category }}</h6>
                <div
                    class="media-article-card__body__underline"
                    [style.backgroundColor]="categoryColor"
                ></div>
            }
            <h4 class="media-article-card__body__title" [class.margin-top-m]="category">
                {{ title }}
            </h4>
            <div
                class="media-article-card__body__footer"
                [class.media-article-card__body__footer--no-date]="!publishedDate"
                [class.media-article-card__body__footer--no-avatar]="!avatar"
            >
                @if (avatar) {
                    <img
                        class="media-article-card__body__footer__avatar"
                        [ngSrc]="avatar"
                        [alt]="(author || '') + ' avatar'"
                        height="20"
                        width="20"
                    />
                }
                @if (author) {
                    <h6
                        class="media-article-card__body__footer__author"
                        [class.padding-left-m]="avatar"
                    >
                        {{ author }}
                    </h6>
                }
                @if (publishedDate) {
                    <p class="media-article-card__body__footer__date">
                        {{ publishedDate }}
                    </p>
                }

                @if (showIcon) {
                    <nw-pill class="media-article-card__body__footer__pill">
                        <div class="media-article-card__body__footer__pill__content">
                            <nw-icon>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 22"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M4.5 3.5c0-1.655 1.345-3 3-3H21c1.655 0 3 1.345 3 3v15c0 1.655-1.345 3-3 3H3.75A3.749 3.749 0 0 1 0 17.75V5c0-.83.67-1.5 1.5-1.5S3 4.17 3 5v12.75c0 .413.337.75.75.75.412 0 .75-.337.75-.75V3.5Zm3 1.125v3.75c0 .623.502 1.125 1.125 1.125h11.25C20.498 9.5 21 8.998 21 8.375v-3.75c0-.623-.502-1.125-1.125-1.125H8.625c-.623 0-1.125.502-1.125 1.125Zm0 8.625c0 .412.338.75.75.75h4.5c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Zm7.5 0c0 .412.338.75.75.75h4.5c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Zm-7.5 4.5c0 .413.338.75.75.75h4.5c.412 0 .75-.337.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Zm7.5 0c0 .413.338.75.75.75h4.5c.413 0 .75-.337.75-.75a.752.752 0 0 0-.75-.75h-4.5a.752.752 0 0 0-.75.75Z"
                                    />
                                </svg>
                            </nw-icon>
                            <span>Article</span>
                        </div>
                    </nw-pill>
                }
            </div>
        </div>
    </a>
}
